import XDate from 'xdate';
import {parseUSPhoneNumber, valid_email} from '~/common/utils';

/*
 * NOTE:
 * This directory is a duplicate of typhoon/assets/js/common/fabric/reducers/details/selectors.js
 * If you are using a selector from here, move it over there and remove it from here!
 */

export const selectDetails = ({details}) => details;
export const selectRequestFailed = ({details}) => details.request.failed;

/** Required fields: [host, start, title, type] */
export const selectType = ({details}) => details.type;
export const selectHost = ({details}) => details.host;
export const selectTimezone = ({details}) => details.known_timezone_abbr;
export const selectTimezoneName = ({details}) => details.known_timezone_name;
export const selectRsvpOff = ({details}) => details.rsvp_off;

export const selectAddress = ({details}) => details.address;
export const selectHasLocation = ({details}) => Boolean(details.location);

export const selectRequiredComplete = ({details}) =>
  Boolean(details.title.trim() && details.host && details.start);

/** Optional fields: [co-host, end] */
export const selectCohostName = ({details}) => details.cohost.name;
export const selectCohostEmail = ({details}) => details.cohost.email;

export const selectCohostEmailValid = ({details}) =>
  valid_email(selectCohostEmail({details})).is_valid;
export const selectCohostNameError = ({details}) =>
  selectCohostEmailValid({details}) && !selectCohostName({details});
const selectCohostEmailMissing = ({details}) =>
  selectCohostName({details}) && !selectCohostEmailValid({details});
export const selectValidCohost = ({details}) =>
  !selectCohostEmailMissing({details}) && !selectCohostNameError({details});

export const selectCoHost = ({details}) => details.cohost;

const gohPlaceholder = [{name: '', email: ''}];
export const selectGuestsOfHonor = ({details}) =>
  details.guestsOfHonor?.guests?.length ? details.guestsOfHonor?.guests : gohPlaceholder;
export const selectGuestsOfHonorUpdated = ({details}) => details.guestsOfHonor?.update;

export const selectHasGuestsOfHonor = ({details}) => details.guestsOfHonor?.guests?.length > 0;
export const selectPhoneNumber = ({details}) => String(details.phoneNumber);
export const selectPhoneNumberIsValid = ({details}) =>
  !selectPhoneNumber({details}) ||
  (selectPhoneNumber({details}) && parseUSPhoneNumber(selectPhoneNumber({details})).is_valid);

export const selectIsEndDateBeforeStartDate = ({details}) => {
  const {start, end} = details;
  if (!end) return false;
  return new Date(end).getTime() - new Date(start).getTime() < 0;
};

/** Allow submission */
export const selectIsDirty = ({details}) => {
  // biome-ignore lint/correctness/noUnusedVariables: existing error
  const {address, cohost, time, timezone, request, ...rest} = details;

  const flattened = {...address, ...cohost, ...time, ...rest};

  return !Object.values(flattened).some((id) => id);
};

export const selectEventDateHasPassed = ({details}) => {
  const {start} = details;
  if (!start) return false;

  const then = new XDate(start);
  const now = new XDate();
  const diff = now.diffDays(then);

  return diff < 0;
};

/** Validate on submit/navigation */
export const selectEventDetailsValid = ({details}, strict = false) => {
  if (selectEventDateHasPassed({details})) return false;
  if (selectIsEndDateBeforeStartDate({details})) return false;
  if (!selectValidCohost({details})) return false;
  if (!selectPhoneNumberIsValid({details})) return false;
  return strict ? selectRequiredComplete({details}) : true;
};

export const eventIsPremium = ({details}) => details.isPremium;
export const eventInEditMode = ({details, ecard}) => details?.inEditMode ?? ecard?.isInEditMode;
export const eventInUpsellMode = ({details}) => details.isUpsellMode;
export const selectUsedAs = ({details}) => details.usedAs;
